import React from 'react';
import * as _ from 'lodash';
import moment from 'moment';

import InOutHistoryUserUnregisteredContext from '../../services/inOutHistoryUserUnregistered/InOutHistoryUserUnregisteredContext';
import Tippy from '../../components/ReactTippy';

import { Confirmation, Information } from '../modals/common/';

import { isNullOrEmpty } from '../../utilities/stringUtil';
import {
  IN_OUT_TYPE,
  DATE_TIME_FORMAT,
  SORT_TYPE,
  ENTRANCE_WORKER_TYPES,
  CCUS_SENT_STATUS,
  DIALOG_STATUS,
  UNIDENTIFIED_LOGS_AUTO_SEND,
} from '../../utilities/constants';
import SessionStorageService from '../../services/utilities/SessionStorageService';

import Styles from '../../styles/componentStyle/inOutHistoryUserUnregistered/inOutHistoryUserUnregistered.scss';

/**
 * 不明な入退場データテーブル
 * */
export const TableLayout = () => {
  // 画面表示
  return (
    <InOutHistoryUserUnregisteredContext.Consumer>
      {({
        state,
        clearDeleteItem,
        deleteUnidentifiedLog,
        changeSort,
        closeDialog,
      }) => (
        <div className={`${Styles.table} master-slide-view__body`}>
          <table className='table'>
            <thead className='table__header'>
              <tr className='table__label'>
                <th className='value-table value-table--table__label'>
                  <div className='value-table__label' />
                </th>
                {data.tableTitles
                  .filter(
                    title =>
                      (!title.name.startsWith('ccus_send_status') &&
                      !title.name.startsWith('check_in_out_field_area_name')) ||
                      (title.name == 'ccus_send_status' && 
                        state.unidentifiedLogsAutoSendFlg == UNIDENTIFIED_LOGS_AUTO_SEND.ON) ||
                      (title.name == 'check_in_out_field_area_name' &&
                        SessionStorageService.getUseWorkerEntranceAppFlg() == 1)
                  )
                  .map((title, index) => (
                    <th
                      className='value-table value-table--table__label'
                      key={index}
                      onClick={() => {
                        if (title.skipSort !== true) {
                          changeSort(title.name);
                        }
                      }}
                    >
                      <div className='value-table__label'>
                        <span
                          className={`${
                            title.skipSort === true
                              ? 'value-table__label-no-sort-icon'
                              : 'value-table__label-with-sort-icon'
                          }`}
                        >
                          {title.label}
                          {state.searchForm.order === title.name &&
                            state.searchForm.sortType === SORT_TYPE.asc.id && (
                              <button className='btn-icon--xs--dark'>
                                <i className='i-sortaz i-1x' />
                              </button>
                            )}
                          {state.searchForm.order === title.name &&
                            state.searchForm.sortType === SORT_TYPE.desc.id && (
                              <button className='btn-icon--xs--dark'>
                                <i className='i-sortza i-1x' />
                              </button>
                            )}
                          {title.skipSort !== true &&
                            state.searchForm.order !== title.name && (
                              <button className='btn-icon--xs--dark btn-icon__sort btn-icon__sort--low-opacity'>
                                <i className='i-sortdefault i-1x' />
                              </button>
                            )}
                        </span>
                      </div>
                    </th>
                  ))}
                <th className='value-table value-table--table__label'>
                  <div className='value-table__label' />
                </th>
              </tr>
            </thead>
            <tbody className='table__body'>
              {state.unidentifiedLogs.map((list, index) => {
                return <FixItems list={list} key={index} />;
              })}
            </tbody>
          </table>

          <Confirmation
            visible={state.deleteItem.id !== ''}
            title={data.title.confirmation.delete}
            confirmButtonText={data.buttonTitle.delete}
            cancelButtonText={data.buttonTitle.back}
            message={<DeleteDialogMessage />}
            isNegative={true}
            onCancel={() => clearDeleteItem()}
            onConfirm={() => deleteUnidentifiedLog()}
          />
          <Information
            title={state.informationModal.title}
            message={state.informationModal.message}
            buttonText={state.informationModal.buttonText}
            multilineText={state.informationModal.multilineText}
            visible={
              state.dialogStatus === DIALOG_STATUS.otherErrorDialogEnabled.id
            }
            onClose={() => closeDialog()}
          />
        </div>
      )}
    </InOutHistoryUserUnregisteredContext.Consumer>
  );
};

/**
 * 不明な入退場データ表示
 * */
const FixItems = ({ list }) => {
  // 画面表示
  return (
    <InOutHistoryUserUnregisteredContext.Consumer>
      {({
        state,
        checkReflectionData,
        changeFieldWorkerTree,
        selectedDeleteItem,
      }) => (
        <tr className='table__item'>
          <td className='gate-list-value-table__name'>
            <input
              type='checkbox'
              name='single-checkbox'
              value={list.id}
              checked={_.includes(state.reflectionUnidentifiedLogList, list)}
              onChange={() => {
                checkReflectionData(list);
              }}
              disabled={
                isNullOrEmpty(list.field_tree_workers) &&
                (isNullOrEmpty(list.field_spot_workers) ||
                  isNullOrEmpty(
                    list.field_spot_workers.find(
                      fsp => !isNullOrEmpty(fsp.field_spot_worker_id)
                    )
                  ))
              }
            />
          </td>
          <td className='gate-list-value-table__name'>
            <p>{list.ccus_engineer_id}</p>
          </td>
          <td className='gate-list-value-table__name'>
            <p>
              {!_.isNil(list.worker_type) &&
                ENTRANCE_WORKER_TYPES[
                  Object.keys(ENTRANCE_WORKER_TYPES).find(
                    worker_type =>
                      ENTRANCE_WORKER_TYPES[worker_type].id === list.worker_type
                  )
                ].name}
            </p>
          </td>
          <td className='gate-list-value-table__name'>
            <WithTooltip>{list.name_sei + list.name_mei}</WithTooltip>
          </td>
          <td className='gate-list-value-table__name'>
            {!isNullOrEmpty(list.field_tree_workers) &&
              list.field_tree_workers.length === 1 && (
                <WithTooltip>
                  {list.field_tree_workers[0].full_company_name}
                </WithTooltip>
              )}
            {!isNullOrEmpty(list.field_tree_workers) &&
              list.field_tree_workers.length > 1 && (
                <select
                  onChange={event => {
                    changeFieldWorkerTree(list, event.target.value);
                  }}
                >
                  {_.map(list.field_tree_workers, item => {
                    return (
                      <option
                        key={item.field_tree_worker_id}
                        value={item.field_tree_worker_id}
                      >
                        {item.full_company_name}
                      </option>
                    );
                  })}
                </select>
              )}
            {!isNullOrEmpty(list.field_spot_workers) && (
              <WithTooltip>
                {list.field_spot_workers[0].full_company_name}
              </WithTooltip>
            )}
            {isNullOrEmpty(list.field_tree_workers) &&
              !isNullOrEmpty(list.company_name) && (
                <WithTooltip>{list.company_name}</WithTooltip>
              )}
          </td>
          <td className='gate-list-value-table__name'>
            <p>
              {moment(new Date(list.record_date_at).toISOString()).format(
                DATE_TIME_FORMAT.slashDateTimeFormat
              )}
            </p>
          </td>
          <td className='gate-list-value-table__name'>
            {_.map(IN_OUT_TYPE, item => {
              if (list.in_out_type === item.Id) {
                return <p key={item.Id}>{item.Name}</p>;
              }
            })}
          </td>
          {state.unidentifiedLogsAutoSendFlg ===
            UNIDENTIFIED_LOGS_AUTO_SEND.ON && (
            <td className='gate-list-value-table__name ccus_send_status'>
              {_.map(CCUS_SENT_STATUS, item => {
                if (list.ccus_send_status === item.id) {
                  return <p key={item.id}>{item.name}</p>;
                }
              })}
            </td>
          )}

          {SessionStorageService.getUseWorkerEntranceAppFlg() == 1 && (
            <td className='gate-list-value-table__name check_in_out_field_area_name'>
              <WithTooltip>{list.check_in_out_field_area_name}</WithTooltip>
            </td>
          )}

          <td className='gate-list-value-table__name check_in_out_record_type_name'>
            {list.check_in_out_record_type_name}
          </td>

          <td className='gate-list-value-table__menu'>
            <button
              className='btn--negative'
              onClick={() => {
                selectedDeleteItem(list);
              }}
            >
              {data.buttonTitle.delete}
            </button>
          </td>
        </tr>
      )}
    </InOutHistoryUserUnregisteredContext.Consumer>
  );
};

/**
 * 不明な入退場データ削除ダイアログメッセージ
 * */
const DeleteDialogMessage = () => {
  // 画面表示
  return (
    <InOutHistoryUserUnregisteredContext.Consumer>
      {({ state }) => (
        <React.Fragment>
          <ul className={Styles.deleteDialog}>
            <li className='flex-box'>
              <span className='flex__label'>{data.tableTitles[0].label}</span>
              <span className='flex__element'>
                {state.deleteItem.ccusEngineerId}
              </span>
            </li>
            <li className='flex-box'>
              <span className='flex__label'>{data.tableTitles[1].label}</span>
              <span className='flex__element'>
                {state.deleteItem.workerType}
              </span>
            </li>
            <li className='flex-box'>
              <span className='flex__label'>{data.tableTitles[2].label}</span>
              <span className='flex__element'>
                {state.deleteItem.workerName}
              </span>
            </li>
            <li className='flex-box'>
              <span className='flex__label'>{data.tableTitles[3].label}</span>
              <span className='flex__element flex__element--scroll'>
                {state.deleteItem.fullCompanyNames.map((name, index) => (
                  <React.Fragment key={index}>
                    {name}
                    {index !== state.deleteItem.fullCompanyNames.length - 1 && (
                      <br />
                    )}
                  </React.Fragment>
                ))}
              </span>
            </li>
            <li className='flex-box'>
              <span className='flex__label'>{data.tableTitles[4].label}</span>
              <span className='flex__element'>
                {state.deleteItem.recordDateAt}
              </span>
            </li>
            <li className='flex-box'>
              <span className='flex__label'>{data.tableTitles[5].label}</span>
              {_.map(IN_OUT_TYPE, item => {
                if (item.Id === state.deleteItem.inOutType) {
                  return (
                    <span className='flex__element' key={item.Id}>
                      {item.Name}
                    </span>
                  );
                }
              })}
            </li>
          </ul>
        </React.Fragment>
      )}
    </InOutHistoryUserUnregisteredContext.Consumer>
  );
};

const WithTooltip = ({ children, className }) => (
  <Tippy
    duration={10}
    distance={24}
    arrowType='sharp'
    delay={[100, 0]}
    placement='bottom'
    followCursor={true}
    html={<div className={Styles.toopTip}>{children}</div>}
  >
    <p className={className}>{children}</p>
  </Tippy>
);

// 定数
const data = {
  buttonTitle: {
    delete: '削除',
    back: '戻る',
  },
  tableTitles: [
    { name: 'ccus_engineer_id', label: 'CCUS技能者ID' },
    { name: 'worker_type', label: '入退場者種別' },
    { name: 'worker_name', label: '氏名' },
    { name: 'full_company_name', label: '会社名', skipSort: true },
    { name: 'record_date_at', label: '記録日時' },
    { name: 'in_out_type', label: '区分' },
    { name: 'ccus_send_status', label: 'CCUS送信' },
    { name: 'check_in_out_field_area_name', label: '打刻エリア' },
    { name: 'check_in_out_record_type_name', label: '打刻方法'},
  ],
  title: {
    confirmation: {
      delete: '本当に削除しますか',
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/tables/InOutHistoryUserUnregisteredTable.jsx